// extracted by mini-css-extract-plugin
module.exports = {"container":"Usuario_container__6G94j","foto":"Usuario_foto__3vkoY","iconeUsuario":"Usuario_iconeUsuario__Asu2l","nomeUsuario":"Usuario_nomeUsuario__3DslC"};